// Generated by `npm --workspace @pleio/icons run generate`, do not edit.
import { type ForwardedRef, forwardRef } from 'react'

import type { IconProps } from '../types'

export const MenuOpenIcon = forwardRef<SVGSVGElement, IconProps>((
    { title, titleId, ...props }: IconProps,
    ref: ForwardedRef<SVGSVGElement>,
) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={12} viewBox="0 0 18 12" display="block" focusable="false" role="img" aria-hidden="true" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<g id="menu-open" fill="none" fillRule="evenodd" stroke="none" strokeWidth={1}><path id="Shape" fill="currentColor" fillRule="nonzero" d="M0 11a1 1 0 0 1 1-1h11a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1m16.6 0-5-5 5-5L18 2.4 14.4 6 18 9.6zM0 6a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1m0-5a1 1 0 0 1 1-1h11a1 1 0 0 1 0 2H1a1 1 0 0 1-1-1" /></g></svg>
))
